import {AbstractModel} from './abstract-model';
import {GoalType} from './goal-type';

export class Goal extends AbstractModel {
  id: number | null = null;
  name: string | null = null;
  identifier: string | null = null;
  types: GoalType[] = [];

  override deserialize(input: any): this {
    super.deserialize(input);

    if (input.types) {
      this.types = input.types.map((type: any) => new GoalType().deserialize(type));
    }

    return this;
  }

  override toString(): string {
    return this.name ?? '';
  }
}
